import { css } from '@emotion/css';

import { m } from '../../motif/m';

export const multiSelectWrapperCss = css`
  position: relative;

  i {
    margin-left: 10px;
    width: 10px;
    cursor: pointer;
  }
`;

export const multiSelectDropdownBaseCss = css`
  height: auto;
  padding: 0;

  .displayNone {
    display: none;
  }

  .searchWrapper {
    padding: 0 ${m('--spacing-xxl')} 0 ${m('--spacing-xs')};
    border: 0;
    min-height: 50px;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    color: ${m('--multi-select-fg-color')};

    input {
      color: inherit;
      font-size: inherit;
      cursor: default;
      min-width: 0px;
      padding-left: ${m('--spacing-xs')};
      flex: 1 1 0%;
    }

    .chip {
      background: ${m('--multi-select-chip-bg-color')};
      color: ${m('--multi-select-fg-color')};
      font-size: inherit;
      padding: ${m('--spacing-xs')};
      margin: 5px;
      cursor: default;

      svg {
        fill: ${m('--multi-select-fg-color')};
      }
    }

    .icon_down_dir {
      right: -60px;
    }
  }

  .optionListContainer {
    background: ${m('--multi-select-bg-color')};
    border-radius: 0 0 ${m('--border-radius-s')} ${m('--border-radius-s')};
    box-shadow: ${m('--box-shadow-l')};
    list-style-type: none;
    padding-left: ${m('--spacing-xs')};
    padding-right: ${m('--spacing-xs')};
    z-index: 51;

    .optionContainer {
      border: none;

      &::-webkit-scrollbar {
        width: 7px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
      }
    }

    .option {
      display: flex;
      align-items: center;
      margin-top: ${m('--spacing-xs')};
      margin-bottom: ${m('--spacing-xs')};
      padding-left: ${m('--spacing-m')};
      padding-right: ${m('--spacing-m')};
      border-radius: 5px;
      color: ${m('--multi-select-option-fg-color')};

      &.selected,
      &.highlight,
      &:hover {
        background: ${m('--multi-select-chip-bg-color')};
        color: ${m('--multi-select-option-fg-color')};
      }

      input[type='checkbox'] {
        height: 17px;
        width: 17px;

        &:checked {
          accent-color: ${m('--multi-select-option-fg-color')};
        }
      }
    }
  }
`;

export const multiSelectArrowCss = css`
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: calc(50% - 5px);
  width: 20px;
  height: 20px;
  margin: -4px;

  svg {
    fill: ${m('--multi-select-fg-color')};
  }

  html[dir='rtl'] & {
    right: unset;
    left: 16px;
  }
`;

export const multiSelectCloseIconCss = css`
  margin: -7px;

  svg {
    fill: ${m('--multi-select-fg-color')};
  }
`;
